import { clearAnalyticsUser } from '@cw-elements/analytics-provider';
import { persistor } from '@redux/store';
import axios from 'axios';
import { clearPendingAnalyticsEvents } from 'src/analytics/analyticsLifecycle';
import { setAnalyticsEventContext } from 'src/analytics/eventContext';
import type { IAuthTokenResponseDTO } from '../../core/models/auth';
import { AuthenticationOptions } from '../../core/models/auth';
import actions from './actions';

export const signInThunk = (code: string) => async (dispatch) => {
  dispatch(actions.SIGN_IN.started());

  try {
    const response = await axios.post<IAuthTokenResponseDTO>(
      `${import.meta.env.VITE_APP_BFF_ANALYTICS}/auth/token`,
      {
        grantType: 'authorization_code',
        code,
        redirectUri: AuthenticationOptions.redirectUri,
        clientId: AuthenticationOptions.clientId,
      }
    );
    const tokens = response.data;
    localStorage.setItem('tokens', JSON.stringify(tokens));

    dispatch(actions.SIGN_IN.success(tokens));
  } catch {
    dispatch(actions.SIGN_IN.error());
  }
};

export const logoutThunk = () => async (dispatch) => {
  dispatch(actions.LOGOUT.started());

  try {
    // Revert analytics to the anonymous identity before leaving (per the analytics-provider docs).
    clearAnalyticsUser();
    setAnalyticsEventContext({});
    clearPendingAnalyticsEvents();

    localStorage.removeItem('tokens');
    const logoutUrl = `${import.meta.env.VITE_APP_CROPWISE_AUTH}/exit`;
    globalThis.window.location.href = logoutUrl;

    setTimeout(() => {
      persistor.purge();
    }, 200);

    dispatch(actions.LOGOUT.success());
  } catch (e) {
    dispatch(actions.LOGOUT.error());
    throw e;
  }
};
